import { FeatureFlag } from "src/constants/FEATURE_FLAGS";
import { useFeatureFlag } from "src/utils/flags";
import { Session } from "../../modules/interface";

export type WorkerBlockBookingFeatureFlag = Pick<
  Session["profile"],
  "userId" | "name" | "fullAddress" | "email" | "type"
>;

export function useWorkerBlockBookingFeatureFlag(profile: WorkerBlockBookingFeatureFlag): boolean {
  const { userId, name, email, fullAddress, type } = profile ?? {};
  return useFeatureFlag<boolean>(
    FeatureFlag.WORKER_BLOCK_BOOKING,
    {
      key: userId,
      name,
      email,
      msa: fullAddress?.metropolitanStatisticalArea,
      facilitymsa: fullAddress?.metropolitanStatisticalArea,
      city: fullAddress?.city,
      state: fullAddress?.state,
      facilityType: type,
    },
    false
  );
}
